// import { RRule } from 'rrule';

// const currentYear = new Date().getFullYear(); // Año actual

// const events = [
//   {
//     title: 'Germinación 🌱',
//     rrule: {
//       freq: RRule.MONTHLY,
//       dtstart: new Date(currentYear, 0, 15), // Día 15 de enero del año actual
//       bymonthday: [15],
//     },
//     allDay: true,
//   },
//   {
//     title: 'Siembra 🌾',
//     rrule: {
//       freq: RRule.MONTHLY,
//       dtstart: new Date(currentYear, 0, 10), // Día 10 de enero del año actual
//       bymonthday: [10],
//     },
//     allDay: true,
//   },
//   {
//     title: 'Poda ✂️',
//     rrule: {
//       freq: RRule.MONTHLY,
//       dtstart: new Date(currentYear, 0, 20), // Día 20 de enero del año actual
//       bymonthday: [20],
//     },
//     allDay: true,
//   },
// ];

// export default events;
import { RRule } from 'rrule';

const currentYear = new Date().getFullYear(); // Año actual

const events = []; // Eliminamos los eventos fijos del 10, 15 y 20

export default events;